// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.second-sidebar {
    /* background-color: #3a393980; */
    background-color: #191818;
    /* border: 3px solid #dee2e6; */
    /* border-radius: 8px; */
    padding: 20px 0px 40px 0px;
    box-shadow: 0 2px 8px rgba(0,0,0,0.1);
    height: 100%;
    overflow-y: auto;
    /* width: 250px; */
    position: relative;
    /* transition: all 0.8s ease; */
  }
  
  .second-sidebar.closed {
    width: 60px;
    padding: 12px;
  }
  
  .sidebar-section {
    margin-bottom: 25px;
    padding-bottom: 15px;
    border-bottom: 1px solid #e9ecef;
  }
  
  .sidebar-section:last-child {
    border-bottom: none;
    margin-bottom: 0;
  }
  
  .sidebar-section h3 {
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 15px;
    color: #2c3e50;
    padding-bottom: 8px;
    border-bottom: 2px solid #667eea;
  }
  
  .sidebar-section h4 {
    font-size: 14px;
    font-weight: 600;
    margin-bottom: 12px;
    color: #495057;
  }
  
  .sidebar-stats {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }
  
  .stat-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 0;
    border-bottom: 1px solid #f1f3f4;
  }
  
  .stat-item:last-child {
    border-bottom: none;
  }
  
  .stat-item span {
    font-size: 13px;
    color: #6c757d;
    font-weight: 500;
  }
  
  .stat-item strong {
    font-size: 14px;
    color: #2c3e50;
    font-weight: 600;
    background: #e9ecef;
    padding: 4px 8px;
    border-radius: 4px;
    min-width: 30px;
    text-align: center;
  }
  
  .purchase-options,
  .notes-options {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }
  
  .sidebar-btn {
    background: white;
    border: 1px solid #dee2e6;
    border-radius: 6px;
    padding: 10px 12px;
    font-size: 13px;
    color: #495057;
    cursor: pointer;
    transition: all 0.2s ease;
    text-align: left;
    font-weight: 500;
  }
  
  .sidebar-btn:hover {
    /* background: #667eea; */
    color: white;
    /* border-color: #667eea; */
    transform: translateY(-1px);
    box-shadow: 0 2px 4px rgba(102, 126, 234, 0.3);
  }
  
  .sidebar-btn:active {
    transform: translateY(0);
  }
  
  /* Toggle Button */
  .toggle-btn {
    /* position: absolute; */
    /* bottom: 20px;
    right: 20px; */
    background: transparent;
    color: white;
    border: none;
    border-radius: 50%;
    width: 36px;
    height: 36px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    /* box-shadow: 0 2px 6px rgba(0,0,0,0.2); */
    transition: all 0.2s ease;
    z-index: 10;
  }
  
  .toggle-btn:hover {
    /* background: #5a6fd8; */
    transform: scale(1.05);
  }
  
  .toggle-icon {
    font-size: 18px;
    transition: transform 0.2s ease;
  }
  
  /* Closed State */
  .second-sidebar.closed .sidebar-section {
    display: none;
  }
  
  /* .second-sidebar.closed .logo {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
  } */
  
  .logo {
    font-size: 24px;
    font-weight: bold;
    color: #667eea;
  }
  
  /* Scrollbar styling */
  .second-sidebar::-webkit-scrollbar {
    width: 6px;
    display:none
  }
  
  .second-sidebar::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 3px;
  }
  
  .second-sidebar::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 3px;
  }
  
  .second-sidebar::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8;
  }
`, "",{"version":3,"sources":["webpack://./src/components/Sidebar/SecondSidebar.css"],"names":[],"mappings":"AAAA;IACI,iCAAiC;IACjC,yBAAyB;IACzB,+BAA+B;IAC/B,wBAAwB;IACxB,0BAA0B;IAC1B,qCAAqC;IACrC,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,+BAA+B;EACjC;;EAEA;IACE,WAAW;IACX,aAAa;EACf;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;IACpB,gCAAgC;EAClC;;EAEA;IACE,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,cAAc;IACd,mBAAmB;IACnB,gCAAgC;EAClC;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;IACf,gCAAgC;EAClC;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;EACpB;;EAEA;;IAEE,aAAa;IACb,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,eAAe;IACf,yBAAyB;IACzB,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;IACzB,YAAY;IACZ,2BAA2B;IAC3B,2BAA2B;IAC3B,8CAA8C;EAChD;;EAEA;IACE,wBAAwB;EAC1B;;EAEA,kBAAkB;EAClB;IACE,wBAAwB;IACxB;kBACc;IACd,uBAAuB;IACvB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,2CAA2C;IAC3C,yBAAyB;IACzB,WAAW;EACb;;EAEA;IACE,yBAAyB;IACzB,sBAAsB;EACxB;;EAEA;IACE,eAAe;IACf,+BAA+B;EACjC;;EAEA,iBAAiB;EACjB;IACE,aAAa;EACf;;EAEA;;;;;KAKG;;EAEH;IACE,eAAe;IACf,iBAAiB;IACjB,cAAc;EAChB;;EAEA,sBAAsB;EACtB;IACE,UAAU;IACV;EACF;;EAEA;IACE,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB","sourcesContent":[".second-sidebar {\n    /* background-color: #3a393980; */\n    background-color: #191818;\n    /* border: 3px solid #dee2e6; */\n    /* border-radius: 8px; */\n    padding: 20px 0px 40px 0px;\n    box-shadow: 0 2px 8px rgba(0,0,0,0.1);\n    height: 100%;\n    overflow-y: auto;\n    /* width: 250px; */\n    position: relative;\n    /* transition: all 0.8s ease; */\n  }\n  \n  .second-sidebar.closed {\n    width: 60px;\n    padding: 12px;\n  }\n  \n  .sidebar-section {\n    margin-bottom: 25px;\n    padding-bottom: 15px;\n    border-bottom: 1px solid #e9ecef;\n  }\n  \n  .sidebar-section:last-child {\n    border-bottom: none;\n    margin-bottom: 0;\n  }\n  \n  .sidebar-section h3 {\n    font-size: 16px;\n    font-weight: 600;\n    margin-bottom: 15px;\n    color: #2c3e50;\n    padding-bottom: 8px;\n    border-bottom: 2px solid #667eea;\n  }\n  \n  .sidebar-section h4 {\n    font-size: 14px;\n    font-weight: 600;\n    margin-bottom: 12px;\n    color: #495057;\n  }\n  \n  .sidebar-stats {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n  }\n  \n  .stat-item {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 10px 0;\n    border-bottom: 1px solid #f1f3f4;\n  }\n  \n  .stat-item:last-child {\n    border-bottom: none;\n  }\n  \n  .stat-item span {\n    font-size: 13px;\n    color: #6c757d;\n    font-weight: 500;\n  }\n  \n  .stat-item strong {\n    font-size: 14px;\n    color: #2c3e50;\n    font-weight: 600;\n    background: #e9ecef;\n    padding: 4px 8px;\n    border-radius: 4px;\n    min-width: 30px;\n    text-align: center;\n  }\n  \n  .purchase-options,\n  .notes-options {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n  }\n  \n  .sidebar-btn {\n    background: white;\n    border: 1px solid #dee2e6;\n    border-radius: 6px;\n    padding: 10px 12px;\n    font-size: 13px;\n    color: #495057;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    text-align: left;\n    font-weight: 500;\n  }\n  \n  .sidebar-btn:hover {\n    /* background: #667eea; */\n    color: white;\n    /* border-color: #667eea; */\n    transform: translateY(-1px);\n    box-shadow: 0 2px 4px rgba(102, 126, 234, 0.3);\n  }\n  \n  .sidebar-btn:active {\n    transform: translateY(0);\n  }\n  \n  /* Toggle Button */\n  .toggle-btn {\n    /* position: absolute; */\n    /* bottom: 20px;\n    right: 20px; */\n    background: transparent;\n    color: white;\n    border: none;\n    border-radius: 50%;\n    width: 36px;\n    height: 36px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    cursor: pointer;\n    /* box-shadow: 0 2px 6px rgba(0,0,0,0.2); */\n    transition: all 0.2s ease;\n    z-index: 10;\n  }\n  \n  .toggle-btn:hover {\n    /* background: #5a6fd8; */\n    transform: scale(1.05);\n  }\n  \n  .toggle-icon {\n    font-size: 18px;\n    transition: transform 0.2s ease;\n  }\n  \n  /* Closed State */\n  .second-sidebar.closed .sidebar-section {\n    display: none;\n  }\n  \n  /* .second-sidebar.closed .logo {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 100%;\n  } */\n  \n  .logo {\n    font-size: 24px;\n    font-weight: bold;\n    color: #667eea;\n  }\n  \n  /* Scrollbar styling */\n  .second-sidebar::-webkit-scrollbar {\n    width: 6px;\n    display:none\n  }\n  \n  .second-sidebar::-webkit-scrollbar-track {\n    background: #f1f1f1;\n    border-radius: 3px;\n  }\n  \n  .second-sidebar::-webkit-scrollbar-thumb {\n    background: #c1c1c1;\n    border-radius: 3px;\n  }\n  \n  .second-sidebar::-webkit-scrollbar-thumb:hover {\n    background: #a8a8a8;\n  }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
